import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capacitate',
  templateUrl: './capacitate.component.html',
  styleUrls: ['./capacitate.component.scss']
})
export class CapacitateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
